<template>
  <div
    v-if="estado.ativa || estado.aviso"
    class="previa-studio"
    :class="{ 'previa-studio--aviso': !estado.ativa }"
    role="status"
  >
    <template v-if="estado.ativa">
      <strong>Prévia do Studio</strong>
      <span>rascunhos de {{ estado.autor }} · dados reais · até {{ horario }}</span>
      <span
        v-if="estado.avisos.length"
        class="previa-studio__erros"
        :title="estado.avisos.join('\n')"
      >
        {{ estado.avisos.length }} rascunho(s) com erro não entraram
      </span>
      <button type="button" class="previa-studio__botao" @click="sair">Sair</button>
    </template>
    <template v-else>
      <span>{{ estado.aviso }}</span>
      <button type="button" class="previa-studio__botao" @click="fecharAviso">Ok</button>
    </template>
  </div>
</template>

<script>
import { estadoPrevia, sair, fecharAviso } from '../services/previaStudio';

export default {
  name: 'PreviaStudioAviso',
  data() {
    return { estado: estadoPrevia };
  },
  computed: {
    horario() {
      return this.estado.expiraEm
        ? this.estado.expiraEm.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        : '';
    },
  },
  methods: {
    sair,
    fecharAviso,
  },
};
</script>

<style scoped>
.previa-studio {
  position: fixed;
  left: 12px;
  bottom: 12px;
  z-index: 2147483000;
  max-width: calc(100vw - 24px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #5b21b6;
  color: #fff;
  font-size: 13px;
  line-height: 1.3;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.previa-studio--aviso {
  background: #b45309;
}

.previa-studio__erros {
  text-decoration: underline dotted;
  cursor: help;
}

.previa-studio__botao {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 6px;
  background: transparent;
  color: inherit;
  font-weight: 600;
  cursor: pointer;
}
</style>
